
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button } from 'ant-design-vue';

@Component({
    name: 'CreateOrderButton',
    components: { Button },
})
export default class CreateOrderButton extends Vue {
    @Prop({ default: false }) private offerHasErrors!: boolean;
    @Prop({ default: true }) private showIcon!: boolean;

    private onClick() {
        this.$emit('order-click');
    }
}
